import {
  cva
} from "../../../chunk-6A7LB5UJ.mjs";
import "../../../chunk-QJVDQ4DQ.mjs";
import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/Card/Card.tsx
import { Text } from "../Text/Text.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
var cardVariants = cva("buyscout-card", {
  variants: {
    variant: {
      glass: "buyscout-card--glass",
      flat: "buyscout-card--flat"
    }
  },
  defaultVariants: {
    variant: "flat"
  }
});
var cardContentVariants = cva("buyscout-card__content", {
  variants: {
    padding: {
      none: "buyscout-card__content--padding-none",
      md: "buyscout-card__content--padding-md"
    }
  },
  defaultVariants: {
    padding: "md"
  }
});
function Card({
  ref,
  variant,
  padding,
  title,
  subheader,
  action,
  children,
  className,
  ...rest
}) {
  const hasHeader = title || subheader || action;
  return /* @__PURE__ */ jsxs("div", { ref, className: cardVariants({ variant, className }), ...rest, children: [
    hasHeader && /* @__PURE__ */ jsxs("div", { className: "buyscout-card__header", children: [
      /* @__PURE__ */ jsxs("div", { className: "buyscout-card__header-text", children: [
        title && /* @__PURE__ */ jsx(Text, { variant: "heading-2", as: "div", className: "buyscout-card__title", children: title }),
        subheader && /* @__PURE__ */ jsx(Text, { variant: "body-secondary", as: "div", className: "buyscout-card__subheader", children: subheader })
      ] }),
      action && /* @__PURE__ */ jsx("div", { className: "buyscout-card__action", children: action })
    ] }),
    children && /* @__PURE__ */ jsx("div", { className: cardContentVariants({ padding }), children })
  ] });
}
Card.displayName = "Card";
var Card_default = Card;
export {
  Card,
  Card_default as default
};
//# sourceMappingURL=Card.mjs.map